import { render } from "./Header.vue?vue&type=template&id=8e3bf906"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Mr.Wu\\Desktop\\Files\\XiHe\\code\\xihe_levelexam_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__